import type { IndeedRobinsearchCredentials } from './indeed.types';
import type { IndeedGraphQLHeaders } from './useIndeedConfig.types';
import { extractCookieFromHeaders, extractCtkFromHeaders } from './useIndeedConfig.interceptor';

type BuildIndeedHeadersParams = {
  ctk: string;
  apiKey: string;
  cookie?: string;
};

export const buildIndeedHeaders = ({ ctk, apiKey, cookie = '' }: BuildIndeedHeadersParams): IndeedGraphQLHeaders => ({
  'content-type': 'application/json',
  'indeed-ctk': ctk,
  'indeed-client-sub-app': 'rezemp-discovery',
  'indeed-client-sub-app-component': './Root',
  'indeed-api-key': apiKey,
  Cookie: cookie,
  referer: 'https://resumes.indeed.com/',
});

export const getIndeedHeadersFromCapturedHeaders = (
  headersMap: Record<string, string> | undefined,
): IndeedGraphQLHeaders | null => {
  if (!headersMap) return null;

  const cookieStr = extractCookieFromHeaders(headersMap);
  const ctk = extractCtkFromHeaders(headersMap, cookieStr);
  const apiKey = headersMap['indeed-api-key'];

  if (!ctk || !cookieStr || !apiKey) return null;

  return buildIndeedHeaders({ ctk, apiKey, cookie: cookieStr });
};

export const getIndeedHeadersFromCredentials = (
  credentials: IndeedRobinsearchCredentials | null,
): IndeedGraphQLHeaders | null => {
  if (!credentials || credentials.status !== 'active') return null;
  if (!credentials.ctk || !credentials.api_key) return null;

  return buildIndeedHeaders({ ctk: credentials.ctk, apiKey: credentials.api_key });
};
